/**
 * Stable CSS class names for E2E — Master data.
 */
export const MD = {
    page: 'master-data-page',
    shellPaper: 'master-data-page__shell',
    loadingSection: 'master-data-page__loading-section',
    breadcrumbSection: 'master-data-page__breadcrumb-section',
    tabsWrap: 'master-data-page__tabs-wrap',
    tabsRoot: 'master-data-page__tabs',
    tabPlatforms: 'master-data-page-input--tab-platforms',
    tabPanelPlatforms: 'master-data-page__tab-panel-platforms',

    platformsRoot: 'master-data-platforms-tab',
    platformsToolbar: 'master-data-platforms-tab__toolbar',
    inputButtonCreatePlatform: 'master-data-platforms-tab-input--button-create-platform',
    platformsGridWrap: 'master-data-platforms-tab__grid-wrap',

    datagridActionsCell: 'master-data-platforms-datagrid-actions-cell',
    inputIconRowActionsMenu: 'master-data-platforms-datagrid-input--icon-row-actions-menu',
    rowActionsMenuPaper: 'master-data-platforms-datagrid__row-actions-menu',
    inputMenuItemRowEdit: 'master-data-platforms-datagrid-input--menu-item-row-edit',
    inputMenuItemRowDelete: 'master-data-platforms-datagrid-input--menu-item-row-delete',

    platformDrawerPaper: 'master-data-platform-drawer',
    platformDrawerBody: 'master-data-platform-drawer__body',
    platformDrawerTitle: 'master-data-platform-drawer__title',
    platformDrawerIdField: 'master-data-platform-drawer__id-field',
    platformDrawerIdLabel: 'master-data-platform-drawer__id-label',
    inputTextPlatformId: 'master-data-platform-drawer-input--text-platform-id',
    platformDrawerNameField: 'master-data-platform-drawer__name-field',
    platformDrawerNameLabel: 'master-data-platform-drawer__name-label',
    inputTextPlatformName: 'master-data-platform-drawer-input--text-platform-name',
    inputButtonPlatformSubmit: 'master-data-platform-drawer-input--button-submit',
} as const;

export const mdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
